import { Injectable } from '@angular/core';
import constantURL from '../constantURL';
import { BaseLoggedInPostService } from './base-logged-in-post.service';


@Injectable({
  providedIn: 'root'
})
/*
params to set
tablename: what is the name of the table to configure (string)
*/
export class FindUserConfigService extends BaseLoggedInPostService {
  _path = constantURL.userConfig.getuserConfig;
}
